var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4911.29 3615.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 213.08,
    y1: 512.79,
    x2: 4698.21,
    y2: 3102.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f2b600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f4570a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f26c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f17ace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f080ed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4615.79,27,2837.71,1185.89l-49.54-972.58C2779.89,50.62,2606.5-49.35,2461.54,25l-1647,1108.56L204.5,781.33c-84.43-48.75-190,12.19-190,109.68V1679.2l-1.21,1L2.69,3190.09c-26.48,409.36,147.86,472.37,292.82,398L2073.58,2429.18l49.54,972.58c8.29,162.7,181.67,262.66,326.63,188.32l1647-1108.56,610.07,352.22c84.43,48.75,190-12.19,190-109.68V1935.87l1.2-1L4908.61,425C4935.08,15.62,4760.74-47.39,4615.79,27Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.681dc7f00c4b1848b35795422d9c00f3.svg";
export { ForwardRef as ReactComponent };